import React from 'react';
import CircleButton from '../../components/CircleButton/CircleButton';
import { CommonConfig, Icons } from '../../config';
import './TeamSection.scss';

const TeamMember = ({ name, title, description, skills, social, avatar }) => (
    <div className="team-member">
        <img src={avatar} alt={name} className="team-avatar" />
        <h2 className="team-name">{name}</h2>
        <h3 className="team-title">{title}</h3>
        <p className="team-description">{description}</p>
        <h4 className="team-skills-header">
            <span className="icon-wrapper">{Icons['code']}</span> Core Competencies
        </h4>
        <div className="team-skills">
            {skills.map(skill => (
                <span key={skill} className="skill-tag">{skill}</span>
            ))}
        </div>
        <h4 className="team-connect-header">
            <span className="icon-wrapper">{Icons['link']}</span> Connect
        </h4>
        <div className="team-social">
            {social.map((socialDetails, index) => (
                <CircleButton key={`social-${index}`} link={socialDetails.link} 
                    target="_blank" tooltip={socialDetails.name} size={2}>
                    {socialDetails.icon || Icons[socialDetails.name.toLowerCase()]}
                </CircleButton>
            ))}
        </div>
    </div>
);

const TeamSection = React.forwardRef((props, ref) => (
      <section className="team-section" ref={ref}>
          <div className="container">
            <h1 className="section-title">Chain Mates</h1>
            <div className="team-container">
                <TeamMember 
                    name="Varad"
                    title="Blockchain Developer"
                    description="I'm a full stack blockchain developer having expertise in architecting complex solutions and writing Smart Contracts."
                    skills={['Solidity', 'DeFi', 'Smart Contracts', 'Cross-Chain','Typescript','Javascript']}
                    social={CommonConfig.varad.social}
                    avatar={require('../../assets/icons/Hephaestus.jpeg')}
                />
                <TeamMember 
                    name="Blockspade"
                    title="Blockchain Developer"
                    description="I'm a full stack blockchain developer with expertise in building decentralized applications (dApps) and smart contracts using Solidity and Web3 tools."
                    skills={['Solidity', 'Ethereum', 'Smart Contracts', 'DeFi', 'Web3.js', 'Blockchain Architecture']}
                    social={CommonConfig.vasu.social}
                    avatar={require('../../assets/icons/Blockspade.jpeg')}
                />
            </div>
        </div>
    </section>
));

export default TeamSection;
